import { render, staticRenderFns } from "./Spread.vue?vue&type=template&id=49ccb0f3&scoped=true&lang=html&"
import script from "./Spread.vue?vue&type=script&lang=js&"
export * from "./Spread.vue?vue&type=script&lang=js&"
import style0 from "./Spread.vue?vue&type=style&index=0&id=49ccb0f3&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49ccb0f3",
  null
  
)

export default component.exports